import { TProductCategoryParentSlug } from 'types/contentful/productCategory'

/**
 * Expect to have only one parent with one slug. Any duplication will return only the first
 * This will match exact slug category. So no **wildcard** accepted
 *
 * @param categories list of categories to filter on parent and slug
 * @param parentSlug parent category slug
 * @param slug category slug
 */
export function getProductCategoryIdInBigcommerce(
  categories: any[],
  parentSlug: TProductCategoryParentSlug,
  slug: string
): { name: string; entityId: number } {
  // Expect only one marketplace or one custom-packaging here
  const parentCategory = categories.filter((key) => {
    return key.path.indexOf(`/${parentSlug}/`) !== -1
  })[0]

  if (!parentCategory) {
    return {
      entityId: 0,
      name: undefined,
    } // default category which doesn't have any product per se
  }

  const slugCategory = parentCategory.children.find((key: any) => {
    return key.path.indexOf(`/${slug?.replace('/', '')}/`) !== -1
  })

  return slugCategory
    ? {
        entityId: slugCategory.entityId,
        name: slugCategory.name,
      }
    : {
        entityId: 0,
        name: undefined,
      }
}
